import './posterbuilder.scss'

import {Formik, useField} from 'formik'
import React, {FunctionComponent} from 'react'

import {FormField} from './formfield'
import {LocationIcon} from 'styles/inline-icons'
import {Theme} from 'views/campagne/theme'
import {style} from 'util/campagne/style'
import {useTranslation} from 'util/i18n'

export type PosterBuilderType = {
	organisation: string
	isSharing: string
	location: string
	organisation_name?: string
	isSharing_name?: string
	location_name?: string
	default_organisation?: string
	default_isSharing?: string
	default_location?: string
}
type AfficheRowType = {}

const styles = style('posterbuilder', ['row', 'raster'])

export const PosterBuilder: FunctionComponent<PosterBuilderType> = ({
	organisation,
	isSharing,
	location,
	organisation_name = 'poster_organiation',
	isSharing_name = 'poster_issharing',
	location_name = 'poster_location'
}) => {
	const t = useTranslation('campagne').affichebuilder
	return (
		<div class={styles}>
			<div class={styles.raster} />
			<div class={styles('content')}>
				<PosterBuilderRow>
					<div class={styles('content-title')}>
						<Theme.H3 mod="nowrap">{t.with}</Theme.H3>
					</div>
					<div class={styles.row('field')}>
						<FormField
							placeholder={organisation}
							id="organisation"
							name={organisation_name}
						/>
					</div>
				</PosterBuilderRow>
				<PosterBuilderRow>
					<div class={styles('content-title')}>
						<Theme.H3 mod="nowrap">{t.we_share}</Theme.H3>
					</div>
					<div class={styles.row('field')}>
						<FormField placeholder={isSharing} name={isSharing_name} />
					</div>
				</PosterBuilderRow>
				<PosterBuilderRow>
					<div class={styles('content-title')}>
						<Theme.H3 mod="nowrap">{t.at}</Theme.H3>
					</div>
					<div class={styles.row('field')}>
						<FormField
							placeholder={location}
							icon={<LocationIcon />}
							name={location_name}
						/>
					</div>
				</PosterBuilderRow>
			</div>
		</div>
	)
}

const PosterBuilderRow: FunctionComponent<AfficheRowType> = ({children}) => {
	return <div class={styles.row}>{children}</div>
}
